// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zLightBlue":"rgb(75, 137, 220)","tertiary":"#BFD730","dot":"_60B0","active":"_28u3"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Dots/Dot/Dot.scss
// module id = lJCc
// module chunks = 0